import { Box, Divider, Stack } from '@mui/material';
import ChatMessageInput from './ChatMessageInput';
import ChatMessageList from './ChatMessageList';

export default function ChatWindow({
  selectedConversation,
  scrollHeightBeforeLoad,
  handleScrollHeightBeforeLoad,
  handleSendMessage,
  handleNextMessage,
  handleDeleteMessage,
  userPic,
  isNextChatMessageLoading,
  userId,
  isSendLoading,
}) {
  const conversationId =
    selectedConversation?.from?.id === userId ? selectedConversation?.to?.id : selectedConversation?.from?.id;
  const getLatestMessageDateFromOtherParticipant = () => {
    if (!selectedConversation?.messages) {
      return null;
    }
    const otherParticipantMessages = selectedConversation?.messages?.filter(
      (message) => message?.from?.id === conversationId
    );
    if (otherParticipantMessages === null || otherParticipantMessages.length === 0) {
      return null;
    }
    otherParticipantMessages.sort((a, b) => new Date(b.created_time) - new Date(a.created_time));

    return otherParticipantMessages && otherParticipantMessages[0].created_time;
  };

  const fromLatestMessageDate = getLatestMessageDateFromOtherParticipant();
  return (
    <Stack sx={{ flexGrow: 1, minWidth: '1px' }}>
      <Divider />

      <Box sx={{ flexGrow: 1, display: 'flex', overflow: 'hidden' }}>
        <Stack sx={{ flexGrow: 1 }}>
          <ChatMessageList
            conversation={selectedConversation}
            scrollHeightBeforeLoad={scrollHeightBeforeLoad}
            handleScrollHeightBeforeLoad={handleScrollHeightBeforeLoad}
            handleNextMessage={handleNextMessage}
            isNextChatMessageLoading={isNextChatMessageLoading}
            handleDeleteMessage={handleDeleteMessage}
            userPic={userPic}
            userId={userId}
          />

          <Divider />

          <ChatMessageInput
            fromLatestMessageDate={fromLatestMessageDate}
            conversationId={conversationId}
            onSend={handleSendMessage}
            isSendLoading={isSendLoading}
            selectedConversation={selectedConversation}
            facebookPageId={userId}
          />
        </Stack>
      </Box>
    </Stack>
  );
}